import {FC} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {BrandBuildingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../../atoms/OfferBoxBase";

interface IProps {
    children: React.ReactNode;
    onClick?: () => void;
}

export const NearbyOffersMoreCard: FC<IProps> = (props) => {
    const theme = useTheme();
    return (
        <OfferBoxBase css={content} onClick={props.onClick}>
            <BrandBuildingIcon size="10" wrapperSize="11.2" wrapperColor={theme.colors.primary} wrapperType="circle" css={iconStyles} />
            <Text align="center" variant="headline_3" css={textStyle}>
                {props.children}
            </Text>
        </OfferBoxBase>
    );
};

const content = css`
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4rem 0;
`;

const iconStyles = css`
    margin-bottom: 3.6rem;
`;

const textStyle = (theme: Theme) => css`
    padding: 0 3.5rem;

    color: ${theme.colors.secondary};

    &:hover,
    &:focus {
        color: ${theme.colors.secondary};
    }
`;
import {FC} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {BrandBuildingIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../../atoms/OfferBoxBase";

interface IProps {
    children: React.ReactNode;
    onClick?: () => void;
}

export const NearbyOffersMoreCard: FC<IProps> = (props) => {
    const theme = useTheme();
    return (
        <OfferBoxBase css={content} onClick={props.onClick}>
            <BrandBuildingIcon size="10" wrapperSize="11.2" wrapperColor={theme.colors.primary} wrapperType="circle" css={iconStyles} />
            <Text align="center" variant="headline_3" css={textStyle}>
                {props.children}
            </Text>
        </OfferBoxBase>
    );
};

const content = css`
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4rem 0;
`;

const iconStyles = css`
    margin-bottom: 3.6rem;
`;

const textStyle = (theme: Theme) => css`
    padding: 0 3.5rem;

    color: ${theme.colors.secondary};

    &:hover,
    &:focus {
        color: ${theme.colors.secondary};
    }
`;
